import React from "react";
import {OwnLoanHistoryRow} from "./OwnLoanHistoryRow";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {GridTable, ResultsPager} from "../../../../Components/Grid";
import {isAdmin} from "../../../../Utilities/LocalStorage/storageUtilities";

interface OwnLoanHistoryViewProps {
    ownLoanHistoryItems: Record<string, any>[];
    ownLoanHistorySearchCriteria: Record<string, any>;
    handleSetOwnLoanHistorySearchCriteria: (criteria: Record<string, any>) => void;
    redirect?: (route: string) => void;
    totalRecords: number;
}

export const OwnLoanHistoryView = ({
                                       ownLoanHistoryItems,
                                       ownLoanHistorySearchCriteria,
                                       handleSetOwnLoanHistorySearchCriteria,
                                       totalRecords
                                   }: OwnLoanHistoryViewProps) => {

    const isOwnLoanHistoryItemsEmpty = isArrayNullOrEmpty(ownLoanHistoryItems);

    const handleOrderClick = (event: React.MouseEvent<HTMLElement>) => {
        let criteria = {...ownLoanHistorySearchCriteria};
        const columnId = (event.target as HTMLElement).dataset.id;
        criteria.UpdateSorting(columnId);
        handleSetOwnLoanHistorySearchCriteria(criteria);
    };

    const handleFirstClick = () => {
        let criteria = {...ownLoanHistorySearchCriteria};
        criteria.First();
        handleSetOwnLoanHistorySearchCriteria(criteria);
    };
    const handlePreviousClick = () => {
        let criteria = {...ownLoanHistorySearchCriteria};
        criteria.Previous();
        handleSetOwnLoanHistorySearchCriteria(criteria);
    };
    const handleNextClick = () => {
        let criteria = {...ownLoanHistorySearchCriteria};
        criteria.Next();
        handleSetOwnLoanHistorySearchCriteria(criteria);
    };
    const handleLastClick = () => {
        let criteria = {...ownLoanHistorySearchCriteria};
        criteria.Last(totalRecords);
        handleSetOwnLoanHistorySearchCriteria(criteria);
    };

    const pager = (isSecondaryPager: boolean) =>
        <ResultsPager
            handleFirstClick={handleFirstClick}
            handlePreviousClick={handlePreviousClick}
            handleNextClick={handleNextClick}
            handleLastClick={handleLastClick}
            isSecondaryPager={isSecondaryPager}
            totalRecords={totalRecords}
            recordsPerPage={ownLoanHistorySearchCriteria.recordsPerPage}
            currentPage={ownLoanHistorySearchCriteria.page}
            disabled={false}
        />;

    return <>
        {pager(false)}
        <GridTable className="searchResults">
            <thead>
            <tr>
                <th onClick={handleOrderClick} className="is-clickable" data-id="ownCatalogTitle">Catalog Title</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="patronName">Patron</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="districtName">District</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="organization">Organization</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="shippingLocationName">Shipping Location</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="dateFulfilledUtc">Order Fulfilled Date</th>
                <th onClick={handleOrderClick} className="is-clickable" data-id="ownLoanStatus">Status</th>
                {
                    isAdmin() &&
                    <th onClick={handleOrderClick} colSpan={isAdmin() ? 9 : 8} className="is-clickable" data-id="ownLoanNotes">Notes</th>
                }
            </tr>
            </thead>
            <tbody>
            {
                !isOwnLoanHistoryItemsEmpty &&
                ownLoanHistoryItems.map((ownLoanHistoryItem: Record<string, any>) => {
                    return <OwnLoanHistoryRow
                        key={ownLoanHistoryItem.ownLoanItemId}
                        ownLoanHistoryItem={ownLoanHistoryItem}
                    />;
                })
            }
            {
                isOwnLoanHistoryItemsEmpty &&
                <tr data-testid={`no-order-row`}>
                    <td colSpan={isAdmin() ? 9 : 8} className={`text-center`}>No results found.</td>
                </tr>
            }
            </tbody>
        </GridTable>
        {pager(true)}
    </>;
};
